<template>
  <div>
    <Head :title="form.name" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-indigo-400 hover:text-indigo-600" href="/admin/konfigurimet/regjionet">Regjionet</Link>
      <span class="text-indigo-400 font-medium">/</span>
      {{ form.name }}
    </h1>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="update">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input v-model="form.name" :error="form.errors.name" class="pb-8 pr-6 w-full lg:w-1/2" label="Emri" />
          <select-input v-model="form.driver_id" :error="form.errors.driver_id" class="pb-8 pr-6 w-full lg:w-1/2" label="Shoferi">
            <option :value="null">Momentalisht pa shofer</option>
            <option v-for="driver in drivers" :key="driver.id" :value="driver.id">{{ driver.name }}</option>
          </select-input>
          <textarea-input v-model="form.towns" :error="form.errors.towns"  class="pb-8 pr-6 w-full lg:w-2/3" label="Qytetet/Lagjet (Vendos një në çdo rresht)"/>
        </div>
        <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
          <button v-if="user.role === 'superadmin'" class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">Fshij</button>
          <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">Edito</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import {Head, Link, usePage} from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'
import {computed} from 'vue'
import Pagination from '@/Shared/Pagination'
import TextareaInput from '@/Shared/TextareaInput'

export default {
  components: {
    Head,
    Icon,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
    TrashedMessage,
    Pagination,
    TextareaInput
  },
  layout: Layout,
  props: {
    region: Object,
    drivers: Array
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        name: this.region.name,
        towns: this.region.towns,
        driver_id: this.region.driver_id
      }),
    }
  },
  methods: {
    update() {
      this.form.put(`/admin/konfigurimet/regjionet/${this.region.id}`)
    },
    destroy() {
      if (confirm('A jeni të sigurt?')) {
        this.$inertia.delete(`/admin/konfigurimet/regjionet/${this.region.id}`)
      }
    },
  },
  setup() {
    const user = computed(() => usePage().props.value.auth.user)
    return {user}
  },
}
</script>
